import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useScrollReveal from "@/hooks/useScrollReveal";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Motivation from "@/components/Motivation";
import Leistungen from "@/components/Leistungen";
import Abrechnung from "@/components/Abrechnung";
import AboutPreview from "@/components/AboutPreview";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import PageSeeds from "@/components/PageSeeds";

export default function Home({ onOpenCookieSettings }) {
  useScrollReveal();
  const location = useLocation();

  // Smooth-scroll to hash when arriving from another route (e.g. /impressum → /#leistungen)
  useEffect(() => {
    if (location.hash) {
      const id = location.hash;
      // Small timeout so layout is fully ready
      setTimeout(() => {
        const el = document.querySelector(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
    }
  }, [location]);

  return (
    <div data-testid="home-page">
      <Navbar onOpenCookieSettings={onOpenCookieSettings} />
      <PageSeeds count={14} scrollSeeds={2} />
      <main>
        <Hero />
        <Motivation />
        <Leistungen />
        <Abrechnung />
        <AboutPreview />
        <Contact />
      </main>
      <Footer onOpenCookieSettings={onOpenCookieSettings} />
    </div>
  );
}
